import { render, staticRenderFns } from "./Formacion.vue?vue&type=template&id=9f533d00&scoped=true&"
import script from "./Formacion.vue?vue&type=script&lang=js&"
export * from "./Formacion.vue?vue&type=script&lang=js&"
import style0 from "./Formacion.vue?vue&type=style&index=0&id=9f533d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f533d00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VContainer,VIcon,VRow,VSimpleTable})
